<script lang="ts">
	import { Col, Row, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
</script>

<div class="welcome-step">
	<div class="welcome-header">
		<div class="welcome-icon">
			<i class="fas fa-radar" aria-hidden="true"></i>
		</div>
		<Text element="h2" class="mb-s">
			{$format('presence_wizard_welcome_title', { default: 'Set up your radar sensor' })}
		</Text>
		<p class="welcome-subtitle">
			{$format('presence_wizard_welcome_subtitle', {
				default:
					'This guide walks you through everything you need to get your radar device working accurately. It only takes a few minutes.',
			})}
		</p>
	</div>

	<div class="feature-list">
		<Row>
			<Col sm="12" md="6" lg="6">
				<div class="feature-item">
					<div class="feature-icon-wrap">
						<i class="fas fa-sliders" aria-hidden="true"></i>
					</div>
					<div class="feature-text">
						<p class="feature-title">
							{$format('presence_wizard_feature_sensor_title', {
								default: 'Sensor setup',
							})}
						</p>
						<p class="feature-body">
							{$format('presence_wizard_feature_sensor_body', {
								default: 'Configure mount height and detection sensitivity',
							})}
						</p>
					</div>
				</div>
			</Col>
			<Col sm="12" md="6" lg="6">
				<div class="feature-item">
					<div class="feature-icon-wrap">
						<i class="fas fa-draw-polygon" aria-hidden="true"></i>
					</div>
					<div class="feature-text">
						<p class="feature-title">
							{$format('presence_wizard_feature_room_title', {
								default: 'Room boundaries',
							})}
						</p>
						<p class="feature-body">
							{$format('presence_wizard_feature_room_body', {
								default: 'Draw your room outline and mark blind spots',
							})}
						</p>
					</div>
				</div>
			</Col>
			<Col sm="12" md="6" lg="6">
				<div class="feature-item">
					<div class="feature-icon-wrap">
						<i class="fas fa-vector-square" aria-hidden="true"></i>
					</div>
					<div class="feature-text">
						<p class="feature-title">
							{$format('presence_wizard_feature_zones_title', {
								default: 'Detection zones',
							})}
						</p>
						<p class="feature-body">
							{$format('presence_wizard_feature_zones_body', {
								default: 'Define areas that trigger automations independently',
							})}
						</p>
					</div>
				</div>
			</Col>
			<Col sm="12" md="6" lg="6">
				<div class="feature-item">
					<div class="feature-icon-wrap">
						<i class="fas fa-couch" aria-hidden="true"></i>
					</div>
					<div class="feature-text">
						<p class="feature-title">
							{$format('presence_wizard_feature_furniture_title', {
								default: 'Furniture layout',
							})}
						</p>
						<p class="feature-body">
							{$format('presence_wizard_feature_furniture_body', {
								default: 'Add visual landmarks to your radar map',
							})}
						</p>
					</div>
				</div>
			</Col>
		</Row>
	</div>
</div>

<style>
	.welcome-step {
		padding: 8px 0;
	}

	.welcome-header {
		text-align: center;
		margin-bottom: 28px;
	}

	.welcome-icon {
		font-size: 40px;
		margin-bottom: 12px;
		color: var(--color-primary, #7c5bff);
	}

	.welcome-subtitle {
		color: var(--color-text-secondary, rgba(255, 255, 255, 0.6));
		max-width: 420px;
		margin: 0 auto;
		line-height: 1.5;
	}

	.feature-list {
		margin-top: 8px;
	}

	.feature-item {
		display: flex;
		align-items: flex-start;
		gap: 12px;
		padding: 12px;
		border-radius: 10px;
		margin-bottom: 8px;
		background: var(--color-surface-2, rgba(255, 255, 255, 0.04));
	}

	.feature-icon-wrap {
		flex-shrink: 0;
		width: 36px;
		height: 36px;
		border-radius: 8px;
		background: var(--color-primary-alpha, rgba(124, 91, 255, 0.15));
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--color-primary, #7c5bff);
		font-size: 15px;
	}

	.feature-text {
		min-width: 0;
	}

	.feature-title {
		margin: 0 0 2px;
		font-weight: 600;
		font-size: 14px;
	}

	.feature-body {
		margin: 0;
		font-size: 13px;
		color: var(--color-text-secondary, rgba(255, 255, 255, 0.55));
		line-height: 1.4;
	}
</style>
